import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { ArrowLeft, Music } from 'lucide-react';

export default function LegalPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [siteSettings, setSiteSettings] = useState({});

  useEffect(() => {
    (async () => {
      try {
        // Carica impostazioni (inclusi URL esterni legali)
        let pubSettings = {};
        try { const { data } = await api.get('/settings/public'); pubSettings = data; setSiteSettings(data); } catch(e) {}

        // Controlla URL esterno
        const externalUrl = pubSettings[`legal_url_${slug}`];
        if (externalUrl) {
          window.location.href = externalUrl;
          return;
        }

        // Carica pagina interna
        const { data } = await api.get(`/legal/${slug}`);
        setPage(data.page);
      } catch (e) {} finally { setLoading(false); }
    })();
  }, [slug]);

  if (loading) return <div className="min-h-screen bg-gray-50 flex items-center justify-center"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-pn-red" /></div>;
  if (!page) return <div className="min-h-screen flex items-center justify-center"><p>Pagina non trovata</p></div>;

  const logoPath = siteSettings.site_logo_path;
  const siteName = siteSettings.site_name || 'PROUD NOIZE';

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1A1A2E] text-white py-4 px-6 flex items-center gap-4">
        <button onClick={() => navigate(-1)} className="hover:text-gray-300"><ArrowLeft size={20} /></button>
        {logoPath ? (
          <img src={logoPath} alt={siteName} className="h-8 object-contain" />
        ) : (
          <><Music size={20} className="text-pn-red" /><h1 className="font-bold">{siteName}</h1></>
        )}
      </header>
      <main className="max-w-3xl mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold text-pn-dark mb-2">{page.title_it}</h1>
        <p className="text-xs text-gray-400 mb-6">v{page.version} · {new Date(page.updated_at).toLocaleDateString('it-IT')}</p>
        <div className="card p-8 prose prose-sm max-w-none"
          style={{ whiteSpace: 'pre-line' }}
          dangerouslySetInnerHTML={{ __html: page.content_it }} />
      </main>
    </div>
  );
}
